import { jsx as _jsx } from "react/jsx-runtime";
import { animated } from '@react-spring/web';
// The editor only grows for typed content, so a placeholder longer than its empty rows must clamp
// instead of painting under the rows below the editor.
const getLineClampStyle = (maxLines) => maxLines === undefined
    ? undefined
    : {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: maxLines,
        overflow: 'hidden',
        overflowWrap: 'anywhere',
    };
export function AnimatedPlaceholder({ className, currentPlaceholder, shouldAnimatePlaceholder, transitions, maxLines, }) {
    const lineClampStyle = getLineClampStyle(maxLines);
    return (_jsx("div", { "aria-hidden": true, className: className, style: shouldAnimatePlaceholder ? undefined : lineClampStyle, children: shouldAnimatePlaceholder
            ? transitions((style, item) => (_jsx(animated.div, { className: "origin-left rtl:origin-right", style: { ...lineClampStyle, ...style, position: 'absolute', inset: 0 }, children: item.text })))
            : currentPlaceholder }));
}
//# sourceMappingURL=useComposerInputPlaceholderComponents.js.map